import React from 'react';
import { FormSubmitButton, FormatText } from '@digital/ui';

export default (props: React.ComponentProps<typeof FormSubmitButton>) => (
  <FormSubmitButton responsive icon="commons-search" {...props}>
    <FormatText id="ui.commons.search" uppercase />
  </FormSubmitButton>
);
